import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    nuvei: {
        transactionStatus: null
    },
    paysafe:{
        transactionStatus: null
    },
    skrill:{
        transactionStatus: null
    },
    sessionId: null,
    errors: null,
    lastFundsAddedToCustomerAccountEvent: null,
};

export const ecommerceSlice = createSlice({
    name: 'ecommerce',
    initialState,
    reducers: {
        //todo: a pattern is emerging here, consider refactoring
        setNuveiTransactionStatus: (state, action)=>{
            const {transactionStatus, error} = action.payload;
            if (transactionStatus)
                state.nuvei.transactionStatus = transactionStatus;
            if (error)
                state.errors = [error];
        },
        resetNuveiTransactionStatus: (state, action)=>{
            state.nuvei.transactionStatus = null;
            state.errors = null;
        },
        setPaysafeTransactionStatus: (state, action)=>{
            const {transactionStatus, error} = action.payload;
            if (transactionStatus)
                state.paysafe.transactionStatus = transactionStatus;
            if (error)
                state.errors = [error];
        },
        resetPaysafeTransactionStatus: (state, action)=>{
            state.paysafe.transactionStatus = null;
            state.errors = null;
        },
        setSkrillTransactionStatus: (state, action)=>{
            const {transactionStatus, error} = action.payload;
            if (transactionStatus)
                state.skrill.transactionStatus = transactionStatus;
            if (error)
                state.errors = [error];
        },
        resetSkrillTransactionStatus: (state, action)=>{
            state.skrill.transactionStatus = null;
            state.errors = null;
        },
        setSessionId: (state, action)=>{
            state.sessionId = action.payload;
        }
    },
    extraReducers: (builder => {
        builder
            .addCase("ws/fundsAddedToCustomerAccount", (state, action)=>{
                if (!isSameSessionId(state.sessionId,action.payload.SessionId))
                    return;
                if( state.nuvei.transactionStatus === "Processing")
                    state.nuvei.transactionStatus = "Approved";
                if( state.paysafe.transactionStatus === "Processing")
                    state.paysafe.transactionStatus = "Approved";
                if( state.skrill.transactionStatus === "Processing")
                    state.skrill.transactionStatus = "Approved";

                state.lastFundsAddedToCustomerAccountEvent = action.payload;

                const currency = action.payload.Currency == "US" ? "USD" : action.payload.Currency;
                if (action.payload.IsFirstDeposit) {
                    window.fbq?.('trackCustom', 'FirstTimeDeposit', {
                        value: action.payload.Amount,
                        currency: currency
                    });
                } else {
                    window.fbq?.('track', 'Purchase', {
                        value: action.payload.Amount,
                        currency: currency
                    });
                }
            })
            .addCase("ws/addFundsFailed", (state, action)=>{
                if (!isSameSessionId(state.sessionId,action.payload.SessionId))
                    return;
                if( state.nuvei.transactionStatus === "Processing")
                    state.nuvei.transactionStatus = "Failed";
                if( state.paysafe.transactionStatus === "Processing")
                    state.paysafe.transactionStatus = "Failed";
                if( state.skrill.transactionStatus === "Processing")
                    state.skrill.transactionStatus = "Failed";
                state.errors = [action.payload.Reason];
                state.lastFundsAddedToCustomerAccountEvent = null;
            })
    })
});

const isSameSessionId = (str1, str2) => {
    const str1Clean = str1.replace(/-/g, '');
    const str2Clean = str2.replace(/-/g, '');
    return str1Clean === str2Clean;
}

export const {
    setSessionId,
    setNuveiTransactionStatus,
    resetNuveiTransactionStatus,
    setPaysafeTransactionStatus,
    resetPaysafeTransactionStatus,
    setSkrillTransactionStatus,
    resetSkrillTransactionStatus
} = ecommerceSlice.actions;

export default ecommerceSlice.reducer;